import React, { useEffect, useState } from 'react';
import {
  getSingleSurvey,
  addFormContent,
  updateFormContent,
  getFormContent,
  surveyResultPreview,
  sharePreviewLink,
} from '../../../api/services/services';
import backArrow from '../../../imgs/BackArrow.svg';
import MainTemplate from '../../templates/MainTemplate';
import PremiumPageLayout from '../../templates/PremiumPageLayout';
// import "./style.css";
import { useNavigate } from 'react-router-dom';
import { Button, Snackbar, Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Row, Col } from 'react-bootstrap';
import MuiAlert from '@mui/material/Alert';
import { Bucket } from '../../../api/config/apiConfig';
import ContactDetailField from '../../molecules/ContactDetailField';
import TextArea from '../../atoms/Textarea';
import DynamicCheckbox from '../../molecules/DynamicCheckbox';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Input from '../../atoms/Input';
import removeImg from '../../../imgs/remove.png';
import { useParams } from 'react-router-dom';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import html2pdf from 'html2pdf.js';
import PackingMaterialDownload from './ClientSide.jsx/download';
import LoadingModal from '../../molecules/LoadingModal';
import PrintComponent from '../PrintComponent';
import moment from 'moment';
import SuperAdminVerifationModal from '../../molecules/SuperAdminVerifationModal';
import { sendSuperAdminVerificationForEdit } from '../PrebidAgreement/creation/service';
import PremiumCard from '../../molecules/PremiumCard';
import SectionHeader from '../../molecules/SectionHeader';
import DescriptionIcon from '@mui/icons-material/Description';
import InventoryIcon from '@mui/icons-material/Inventory';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ShareWithClientsModal from '../../molecules/ShareWithClients';

const PackingMaterialIssuedPage = () => {
  const [isShare, setIsShare] = useState(false);
  const { surveyId, id, flg } = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState('');
  const [isEdit, setIsEdit] = useState(flg == '1' ? true : false);

  const [isLoading, setIsLoading] = useState(false);
  const [formContent, setFormContent] = useState({
    dataRows: [
      // {
      //   description: "",
      //   date1: "",
      //   date2: "",
      //   date3: "",
      //   date4: "",
      //   date5: "",
      //   date6: "",
      //   date7: "",
      //   qtyUsed: "",
      //   qtyReturned: "",
      // },
    ],
    customerName: '',
    customerEmail: '',
    packingShifting: '',
    vehicles: '',
    packers: '',
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleAddNewDataRows = () => {
    let fC = { ...formContent };
    const values = [...formContent?.dataRows];

    values.push({
      packingMaterial: '',
      date1: '',
      date2: '',
      date3: '',
      date4: '',
      date5: '',
      date6: '',
      date7: '',
      qtyUsed: '',
      qtyReturned: '',
    });
    fC.dataRows = values;

    setFormContent(fC);
  };

  const handleRemoveDataRows = (ind) => {
    let fC = { ...formContent };
    const values = [...formContent?.dataRows];
    values.splice(ind, 1);
    fC.dataRows = values;
    setFormContent(fC);
  };

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.customerName = `${response?.data?.data?.surveyDetail?.name}`;
        values.customerEmail = `${response?.data?.data?.surveyDetail?.email}`;

        // let items = [];

        // let itemsInd = 0;

        // // console.log(response?.data?.data?.surveyDetail?.surveyResult?.surveyRooms)
        // response?.data?.data?.surveyDetail?.surveyResult?.surveyRooms?.forEach(
        //   (rm, ind) => {
        //     // console.log(rm?.roomItems);
        //     rm?.roomItems?.forEach((rmIt) => {
        //       // console.log(itemsInd);
        //       // console.log(values.dataRows);

        //       // Adding a new object to the dataRows array
        //       values.dataRows.push({ description: rmIt?.name });
        //       itemsInd += 1;
        //     });
        //   }
        // );
        // // console.log(values)

        setFormContent(values);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status == 'submitted') getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };
          values.customerName = `${response?.data?.data?.name}`;
          values.customerEmail = `${response?.data?.data?.email}`;

          setFormContent(values);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }
      });
  };

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: [],
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage(
          'Packing Material Issued Sheet has been added successfully!',
        );
        setOpenSnackbar(true);
        navigate(-1);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: [],
      removedMediaKeys: [],
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage(
          'Packing Material Issued Sheet has been updated successfully!',
        );
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (flg == '1') getSurvey();
    else getContent();
  }, []);

  const shareWithClient = (data) => {
    let ems = [];
    data.map((dt) => {
      if (dt.trim().length != 0) {
        ems.push(dt);
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: 'packing-material-issued-sheet-preview',
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          'Packing Material Issued Sheet has been shared with the respective emails successfully!',
        );
        setOpenSnackbar(true);
        setIsLoading(false);
        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);
        setIsLoading(false);
      });
  };

  const printAction = () => {
    // Simply trigger the print dialog.
    // The table-based layout in PrintComponent handles pagination automatically.
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };

  // Actions for the page header
  const pageActions = (
    <>
      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => sendEditRequestToAdmin()}
          disabled={isEditLoading}
          startIcon={<NoteAltIcon />}
          sx={{
            textTransform: 'none',
            borderRadius: 'var(--radius-md)',
            padding: '10px 24px',
            fontWeight: 700,
            backgroundColor: 'var(--primary-color)',
            boxShadow: '0 4px 12px rgba(79, 70, 229, 0.2)',
            '&:hover': { backgroundColor: 'var(--primary-hover)' },
          }}
        >
          Edit
        </Button>
      )}

      {/* {!isEdit && (
        <Button
           variant="outlined"
          onClick={() => setIsShare(true)}
          disabled={isLoading}
           sx={{
            textTransform: "none",
            borderRadius: "var(--radius-md)",
            padding: "10px 24px",
            fontWeight: 700,
            border: "1px solid var(--glass-border)",
            color: "var(--text-main)",
            '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
          }}
        >
          Share
        </Button>
      )} */}

      {isEdit && flg == '2' && (
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            getContent();
            setIsEdit(false);
          }}
          disabled={isLoading}
          sx={{
            textTransform: 'none',
            borderRadius: 'var(--radius-md)',
            fontWeight: 700,
            padding: '10px 24px',
            border: '1px solid',
          }}
        >
          Cancel
        </Button>
      )}

      {isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            if (flg == '1') addContent();
            else updateContent();
          }}
          disabled={isLoading}
          sx={{
            textTransform: 'none',
            borderRadius: 'var(--radius-md)',
            padding: '10px 32px',
            fontWeight: 700,
            backgroundColor: 'var(--primary-color)',
            boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
            '&:hover': { backgroundColor: 'var(--primary-hover)' },
          }}
        >
          Save
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                                const tempTitle = document.title;
            const newTitle = `Packing Material Issue Sheet-${formContent?.customerName || 'Document'}-${moment().format('DD.MM.YYYY')}`;
            document.title = newTitle;

            // Call printAction which handles the print
            printAction();

            // Restore title after a longer delay to ensure print dialog caught it
            setTimeout(() => {
              document.title = tempTitle;
            }, 2000);
          }}
          disabled={isLoading}
          startIcon={<DescriptionIcon />}
          sx={{
            textTransform: 'none',
            borderRadius: 'var(--radius-md)',
            padding: '10px 24px',
            fontWeight: 700,
            backgroundColor: 'var(--text-main)',
            boxShadow: '0 4px 12px rgba(15, 23, 42, 0.2)',
            '&:hover': { backgroundColor: '#000' },
          }}
        >
          Save as PDF
        </Button>
      )}
    </>
  );

  return (
    <>
      <PremiumPageLayout
        title="Packing Material Issued Sheet"
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        {/* Section 1: Customer Details */}
        <PremiumCard sx={{ mb: 4 }}>
          <SectionHeader title="Customer Details" icon={<PersonIcon />} />
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <ContactDetailField
                    label="Customer Name/Organization"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.customerName}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.customerName = e.target.value;
                      setFormContent(values);
                    }}
                    minWidth={'220px'}
                    disabled
                  />
                  <ContactDetailField
                    label="Packing/Shifting Date"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.packingShifting}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.packingShifting = e.target.value;
                      setFormContent(values);
                    }}
                    minWidth={'220px'}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ContactDetailField
                    label="Vehicles used for move"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.vehicles}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.vehicles = e.target.value;
                      setFormContent(values);
                    }}
                    minWidth={'220px'}
                  />
                  <ContactDetailField
                    label="Packers used for move"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.packers}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.packers = e.target.value;
                      setFormContent(values);
                    }}
                    minWidth={'220px'}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </PremiumCard>

        {/* Section 2: Material Inventory */}
        <PremiumCard>
          <SectionHeader title="Issued Materials" icon={<InventoryIcon />} />

          {/* Table Container */}
          <div
            className="premium-table-container mb-4 Weight-Ticket-Table"
            style={{ width: '100%', maxWidth: '100%' }}
          >
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                maxHeight: 800,
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
              }}
            >
              <Table stickyHeader size="small">
                {/* Table Header */}
                <TableHead>
                  <TableRow>
                    <TableCell
                      className="fw-bold"
                      style={{
                        backgroundColor: '#f8fafc',
                        color: '#1e293b',
                        borderBottom: '2px solid #e2e8f0',
                        width: '60px',
                      }}
                    >
                      No.
                    </TableCell>
                    <TableCell
                      className="fw-bold"
                      style={{
                        backgroundColor: '#f8fafc',
                        color: '#1e293b',
                        borderBottom: '2px solid #e2e8f0',
                      }}
                    >
                      Item Name
                    </TableCell>
                    <TableCell
                      className="fw-bold"
                      style={{
                        backgroundColor: '#f8fafc',
                        color: '#1e293b',
                        borderBottom: '2px solid #e2e8f0',
                        width: '160px',
                      }}
                    >
                      Date Issued
                    </TableCell>
                    <TableCell
                      className="fw-bold"
                      style={{
                        backgroundColor: '#f8fafc',
                        color: '#1e293b',
                        borderBottom: '2px solid #e2e8f0',
                        width: '120px',
                      }}
                    >
                      Qty Issued
                    </TableCell>
                    <TableCell
                      className="fw-bold"
                      style={{
                        backgroundColor: '#f8fafc',
                        color: '#1e293b',
                        borderBottom: '2px solid #e2e8f0',
                        width: '120px',
                      }}
                    >
                      Qty Used
                    </TableCell>
                    <TableCell
                      className="fw-bold"
                      style={{
                        backgroundColor: '#f8fafc',
                        color: '#1e293b',
                        borderBottom: '2px solid #e2e8f0',
                        width: '140px',
                      }}
                    >
                      Qty Returned
                    </TableCell>
                    {isEdit && (
                      <TableCell
                        className="fw-bold"
                        style={{
                          backgroundColor: '#f8fafc',
                          color: '#1e293b',
                          borderBottom: '2px solid #e2e8f0',
                          width: '50px',
                        }}
                      ></TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formContent?.dataRows?.length > 0 ? (
                    <>
                      {formContent?.dataRows?.map((row, index) => {
                        return (
                          <TableRow key={index} hover>
                            <TableCell> {index + 1}</TableCell>
                            <TableCell>
                              {isEdit ? (
                                <Input
                                  id="condition"
                                  label="Description..."
                                  type="text"
                                  style="full-border-field"
                                  value={row?.description}
                                  onChange={(e) => {
                                    const values = { ...formContent };
                                    const valuesRows = [
                                      ...formContent?.dataRows,
                                    ];
                                    valuesRows[index].description =
                                      e.target.value;
                                    values.dataRows = valuesRows;
                                    setFormContent(values);
                                  }}
                                  inline={{ width: '100%' }}
                                />
                              ) : (
                                row.description || '-'
                              )}
                            </TableCell>
                            <TableCell>
                              {isEdit ? (
                                <Input
                                  id="condition"
                                  label="Date..."
                                  type="date"
                                  style="full-border-field"
                                  value={row?.date1}
                                  onChange={(e) => {
                                    const values = { ...formContent };
                                    const valuesRows = [
                                      ...formContent?.dataRows,
                                    ];
                                    valuesRows[index].date1 = e.target.value;
                                    values.dataRows = valuesRows;
                                    setFormContent(values);
                                  }}
                                  inline={{ width: '100%' }}
                                />
                              ) : row.date1 ? (
                                formatDate(row.date1)
                              ) : (
                                '-'
                              )}
                            </TableCell>

                            <TableCell>
                              {isEdit ? (
                                <Input
                                  id="condition"
                                  label="Qty..."
                                  type="number"
                                  style="full-border-field"
                                  value={row?.qtyIssued}
                                  onChange={(e) => {
                                    const values = { ...formContent };
                                    const valuesRows = [
                                      ...formContent?.dataRows,
                                    ];
                                    valuesRows[index].qtyIssued =
                                      e.target.value;
                                    values.dataRows = valuesRows;
                                    setFormContent(values);
                                  }}
                                  inline={{ width: '100%' }}
                                />
                              ) : (
                                row?.qtyIssued || '-'
                              )}
                            </TableCell>

                            <TableCell>
                              <div style={{ padding: isEdit ? '12px 0' : '0' }}>
                                {row.qtyIssued || row?.qtyReturned ? (
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      fontWeight: 600,
                                      color: 'var(--primary-color)',
                                    }}
                                  >
                                    {Number(row.qtyIssued || 0) -
                                      Number(row.qtyReturned || 0)}
                                  </Typography>
                                ) : (
                                  '-'
                                )}
                              </div>
                            </TableCell>

                            <TableCell>
                              {isEdit ? (
                                <Input
                                  id="condition"
                                  label="Qty..."
                                  type="number"
                                  style="full-border-field"
                                  value={row?.qtyReturned}
                                  onChange={(e) => {
                                    const values = { ...formContent };
                                    const valuesRows = [
                                      ...formContent?.dataRows,
                                    ];
                                    valuesRows[index].qtyReturned =
                                      e.target.value;
                                    values.dataRows = valuesRows;
                                    setFormContent(values);
                                  }}
                                  inline={{ width: '100%' }}
                                />
                              ) : (
                                row.qtyReturned || '-'
                              )}
                            </TableCell>

                            {isEdit && (
                              <TableCell>
                                <Button
                                  onClick={() => handleRemoveDataRows(index)}
                                  sx={{
                                    minWidth: 'auto',
                                    p: 0.5,
                                    color: '#ef4444',
                                  }}
                                >
                                  <CancelIcon fontSize="small" />
                                </Button>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell
                        className="text-center"
                        colSpan={isEdit ? 7 : 6}
                      >
                        {isLoading ? (
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              my: 3,
                            }}
                          >
                            <CircularProgress
                              size={24}
                              sx={{ color: 'var(--primary-color)' }}
                            />
                          </Box>
                        ) : (
                          <Typography sx={{ py: 3, color: '#64748b' }}>
                            No Records to Show
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {isEdit && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant="outlined"
                startIcon={<EditIcon />}
                onClick={handleAddNewDataRows}
                sx={{
                  textTransform: 'none',
                  borderRadius: '8px',
                  fontWeight: 600,
                  borderColor: 'var(--primary-color)',
                  color: 'var(--primary-color)',
                }}
              >
                Add New Row
              </Button>
            </Box>
          )}
        </PremiumCard>

        <LoadingModal
          open={isLoading}
          handleClose={() => setIsLoading(false)}
        />
      </PremiumPageLayout>

      <PrintComponent>
        <PackingMaterialDownload formContent={formContent} />
      </PrintComponent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes('successful') ? 'success' : 'error'
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      <ShareWithClientsModal
        open={isShare}
        onClose={() => setIsShare(false)}
        onSuccess={shareWithClient}
      />

      {isVerified && (
        <SuperAdminVerifationModal
          open={isVerified}
          onClose={() => setIsVerified(false)}
          onSuccess={() => {
            setIsEdit(true);
            setIsVerified(false);
          }}
          onError={() => {
            setSnackbarMessage('Invalid Confirm Pin');
            setOpenSnackbar(true);
          }}
        />
      )}
    </>
  );
};
export default PackingMaterialIssuedPage;
